import { render, staticRenderFns } from "./AttributesUpdaterView.vue?vue&type=template&id=5204877c&scoped=true&"
import script from "./AttributesUpdaterView.vue?vue&type=script&lang=js&"
export * from "./AttributesUpdaterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5204877c",
  null
  
)

export default component.exports